module.exports = __webpack_public_path__ + "static/media/cases_3d_02c.6063b2c0.jpg";